import axios from 'axios';

class Api {
  constructor() {
    this.client = axios.create({
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    })
  }

  async get(uri, params, configs) {
    return this.call(uri, {method: 'get', params: Api.normalizeData(params), ...configs})
  }

  async post(uri, data, config={}) {
    return this.call(uri, {...config, method: 'post', data: Api.normalizeData(data)})
  }

  async put(uri, data) {
    return this.call(uri, {method: 'put', data: Api.normalizeData(data)})
  }

  async delete(uri) {
    return this.call(uri, {method: 'delete'})
  }

  async patch(uri, data = {}) {
    return this.call(uri, {method: 'patch', data: Api.normalizeData(data)})

  }

  async call(uri, config) {
    const url = Drupal.url(uri)
    return this.client(url, config)
      .then(res => {
        return Promise.resolve(res.data);
      })
      .catch(err => {
        if (!axios.isCancel(err)) {
          return Promise.reject(err)
        }
      })
  }

  static normalizeData(data) {
    if(typeof data !== 'object' || data === null) {
      return data
    }

    if(Array.isArray(data)) {
      return data.map(Api.normalizeData)
    }

    Object.keys(data).forEach(fieldName => {
      data[fieldName] = Api.normalizeData(data[fieldName])
    })

    return data
  }
}

export default new Api()
